const MacIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5574 10.5092C15.5488 9.04395 16.2127 7.93965 17.5533 7.12539C16.8035 6.05117 15.6691 5.46035 14.1738 5.34648C12.758 5.23477 11.209 6.17148 10.6418 6.17148C10.0424 6.17148 8.67168 5.38516 7.59316 5.38516C5.36738 5.41953 3.00195 7.15977 3.00195 10.7004C3.00195 11.7467 3.19317 12.8273 3.57559 13.9402C4.08692 15.4055 5.93027 18.9955 7.85313 18.9375C8.85859 18.9139 9.56973 18.2242 10.8781 18.2242C12.1479 18.2242 12.8053 18.9375 13.9268 18.9375C15.8668 18.9096 17.534 15.6461 18.0195 14.1766C15.4178 12.9498 15.5574 10.5844 15.5574 10.5092ZM13.2994 3.95644C14.3887 2.66309 14.2898 1.48574 14.2576 1.0625C13.2951 1.11836 12.1822 1.71777 11.5484 2.45469C10.8502 3.24531 10.4398 4.22285 10.5279 5.325C11.5678 5.40449 12.5174 4.86953 13.2994 3.95644Z"
        fill="white"
      />
    </svg>
  );
};

export default MacIcon;
